import axios from "axios";
import { stage_url } from "../api-urls";
import Headers from "./Headers";

export const earningsCalulatorbyBrand = async (payload) => {
    return await axios.get(`${stage_url}v2/earning/brand/calculate`, {
        params: payload,
        headers: Headers.getHeaders(true)
    })
}